import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getParents, setNewParentData } from "../../AxiosRtk/AddNewParent";
import { useLocation } from "react-router-dom";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";
import { useSelector, useDispatch } from "react-redux";
import DeleteAccount from "../modals/DeleteAccount";
import ParentListRow from "./ParentListRow";
import useSubscription from "../../../customHooks/subscriptionProvider";
import { constant } from "../../../../utils/constant";

const ParentsList = () => {
  const history = useHistory();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [addParentSelection, setAddParentSelection] = useState(null);
  const dispatch = useDispatch();
  const { checkSubsciption } = useSubscription();

  const openEditModal = (data) => {
    dispatch(setNewParentData(data));
    setShowEdit(true);
  }
  const openModal = (data) => {
    setAddParentSelection(data)
    setShowModal(true);
  };
  const closeModal = () => {
    // getAllParentData();
    setShowModal(false);
  };
  const [parentData, setParentData] = useState([]);

  function getAllParentData() {
    setLoading(true);
    getParents()
      .then((res) => {
        setParentData(res?.data?.result);
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  useEffect(() => {
    getAllParentData();
  }, [location?.state?.load]);

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="d-flex gap-2 align-items-center justify-content-between mb-6">
            <h3>List of parents</h3>
            <button className="btn btn-outline-primary custom-file-wrap d-inline-flex align-items-center gap-1 mb-6">
              <i className="icon-plus fs-6" />
              <span
                className="btn-upper-case"
                onClick={() => {
                  if (!checkSubsciption()) {
                    return;
                  }
                  history.push("/add-new-parent")
                }}
              >
                Add new parent
              </span>
            </button>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">name</th>
                  <th scope="col">email</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {parentData?.map((data) => (
                  <ParentListRow
                    item={data}
                    key={data?.ID}
                    openEditModal={openEditModal}
                    openModal={openModal}
                    showModal={showModal}
                    closeModal={closeModal}
                    setLoading={setLoading}
                    loading={loading}
                    getAllParentData={getAllParentData}
                    checkSubsciption={checkSubsciption}
                  />
                ))}
              </tbody>
            </table>

            {
              loading && (
                <div className="my-3">
                  <LoadingIndicator height={20} width={100} color={constant?.color?.DODGER_BLUE} />
                </div>
              )
            }

            {
              !loading && parentData?.length === 0 && (
                <div className="my-3 text-center text-capitalize">
                  -- no additional parent found --
                </div>
              )
            }

          </div>

        </div>
      </div>
      {showEdit &&
        history.push({
          pathname: '/edit-new-parent'
        })
      }
      <DeleteAccount
        showModal={showModal}
        closeModal={closeModal}
        setLoading={setLoading}
        loading={loading}
        getAllParentData={getAllParentData}
        parentId={addParentSelection}
      />
    </>
  );
};

export default ParentsList;
